import { ClosureState, ClosureActionTypes } from './types';
import { Reducer } from 'redux';

const initialState: ClosureState = {
  loading: false,
  updated: false,
  data: undefined,
  errors: undefined
};

const reducer: Reducer<ClosureState> = (state = initialState, action) => {
  switch (action.type) {
    case ClosureActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case ClosureActionTypes.FETCH_SUCCESS: {
      const data = action.payload.data;
      return { ...state, loading: false, data, updated: true, errors: undefined };
    }
    case ClosureActionTypes.FETCH_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export { reducer as ClosureReducer };



// WEBPACK FOOTER //
// ./src/store/closure/reducer.ts